import { NotificationBlastContact } from 'messages/hooks/useMessageOverview'

export interface MessageRecipientGroups {
  emailPersons: NotificationBlastContact[]
  smsPersons: NotificationBlastContact[]
  failedRecipients: NotificationBlastContact[]
}

export const getMessageRecipientGroups = (
  contacts: NotificationBlastContact[],
  { emailsOnly = false, smsOnly = false }: { emailsOnly?: boolean; smsOnly?: boolean } = {},
): MessageRecipientGroups =>
  contacts.reduce(
    (acc, contact) => {
      if (contact.doNotContact || contact.failureReason) {
        acc.failedRecipients.push(contact)
        return acc
      }

      if (smsOnly) {
        if (contact.phoneNumber && !contact.isPhoneBounced) {
          acc.smsPersons.push(contact)
        } else {
          acc.failedRecipients.push(contact)
        }
        return acc
      }

      if (emailsOnly) {
        if (contact.email && !contact.isEmailBounced) {
          acc.emailPersons.push(contact)
        } else {
          acc.failedRecipients.push(contact)
        }
        return acc
      }

      if (contact.sendToPhone) {
        acc.smsPersons.push(contact)
      } else if (contact.email) {
        acc.emailPersons.push(contact)
      } else {
        acc.failedRecipients.push(contact)
      }
      return acc
    },
    {
      emailPersons: [],
      smsPersons: [],
      failedRecipients: [],
    } as MessageRecipientGroups,
  )
